import * as React from "react";

function SvgComponent() {
  return <img width="40" src={`/${process.env.REACT_APP_IMAGE}`} alt="office" className="radius6" />;
}

export default SvgComponent;
